
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.14.0
 * Query Engine version: e9771e62de70f79a5e1c604a2d7c8e2a0a874b48
 */
Prisma.prismaVersion = {
  client: "5.14.0",
  engine: "e9771e62de70f79a5e1c604a2d7c8e2a0a874b48"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.ProjectScalarFieldEnum = {
  id: 'id',
  token: 'token',
  channelSecret: 'channelSecret'
};

exports.Prisma.ClueScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  partnerClueId: 'partnerClueId',
  phone: 'phone',
  wechatSeatName: 'wechatSeatName',
  wechatSeatPhone: 'wechatSeatPhone',
  isWechatPass: 'isWechatPass',
  useRandomWechatSeat: 'useRandomWechatSeat',
  info0: 'info0',
  info1: 'info1',
  info2: 'info2',
  info3: 'info3',
  info4: 'info4',
  info5: 'info5',
  info6: 'info6',
  info7: 'info7',
  info8: 'info8',
  info9: 'info9',
  price: 'price',
  courseChannel: 'courseChannel',
  courseName: 'courseName',
  targetTime: 'targetTime'
};

exports.Prisma.ClueStatusScalarFieldEnum = {
  id: 'id',
  clueId: 'clueId',
  clueStatus: 'clueStatus',
  wechatStatus: 'wechatStatus',
  manualType: 'manualType',
  createdAt: 'createdAt'
};

exports.Prisma.CallRecordScalarFieldEnum = {
  id: 'id',
  clueId: 'clueId',
  recordId: 'recordId',
  summary: 'summary',
  intentionalResult: 'intentionalResult',
  direction: 'direction',
  callMakeTime: 'callMakeTime',
  callStatus: 'callStatus',
  recordSoundUrl: 'recordSoundUrl',
  recordHistory: 'recordHistory',
  createdAt: 'createdAt'
};

exports.Prisma.PushRecordScalarFieldEnum = {
  id: 'id',
  callId: 'callId',
  contextId: 'contextId',
  direction: 'direction',
  callMakeTime: 'callMakeTime',
  callRingTime: 'callRingTime',
  callAnswerTime: 'callAnswerTime',
  callHangupTime: 'callHangupTime',
  recordUrl: 'recordUrl',
  summary: 'summary',
  intentionRank: 'intentionRank',
  intentionStatus: 'intentionStatus',
  intentionRes: 'intentionRes',
  content: 'content'
};

exports.Prisma.SmsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  country: 'country',
  phone: 'phone',
  code: 'code',
  sms_type: 'sms_type',
  state: 'state'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastActivityAt: 'lastActivityAt',
  name: 'name',
  nickName: 'nickName',
  phone: 'phone',
  password: 'password',
  email: 'email',
  emailVerified: 'emailVerified',
  plan: 'plan',
  image: 'image',
  wxOpenId: 'wxOpenId',
  state: 'state',
  available: 'available',
  city: 'city'
};

exports.Prisma.UserExtraScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  role: 'role',
  userId: 'userId',
  organizationName: 'organizationName',
  city: 'city',
  contact: 'contact',
  phone: 'phone',
  businessScope: 'businessScope',
  known: 'known'
};

exports.Prisma.UserApplyHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  registerDate: 'registerDate',
  avatar: 'avatar',
  userPhone: 'userPhone',
  role: 'role',
  organizationName: 'organizationName',
  city: 'city',
  contact: 'contact',
  phone: 'phone',
  businessScope: 'businessScope',
  known: 'known',
  accept: 'accept',
  applyDate: 'applyDate',
  userId: 'userId'
};

exports.Prisma.WorkspaceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  fullname: 'fullname',
  name: 'name',
  phone: 'phone',
  plan: 'plan',
  balance: 'balance',
  username: 'username',
  agencyId: 'agencyId',
  icon: 'icon',
  isOnline: 'isOnline'
};

exports.Prisma.MemberInWorkspaceScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  workspaceId: 'workspaceId',
  role: 'role'
};

exports.Prisma.AgencyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  state: 'state'
};

exports.Prisma.ProgramCategoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name'
};

exports.Prisma.ProgramScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  icon: 'icon',
  name: 'name',
  short: 'short',
  description: 'description',
  status: 'status',
  workspaceId: 'workspaceId',
  categoryId: 'categoryId',
  agencyId: 'agencyId',
  isShow: 'isShow',
  wechatType: 'wechatType',
  isSmsWechat: 'isSmsWechat',
  callType: 'callType',
  operationType: 'operationType',
  seatNumber: 'seatNumber',
  flowType: 'flowType',
  pss: 'pss',
  hashrateFee: 'hashrateFee',
  smsFee: 'smsFee',
  effectPrice: 'effectPrice',
  judgeMode: 'judgeMode',
  frequency: 'frequency',
  concurrency: 'concurrency',
  blockStartTime: 'blockStartTime',
  blockEndTime: 'blockEndTime'
};

exports.Prisma.TrunkScriptScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  clue: 'clue',
  blocks: 'blocks',
  extract: 'extract'
};

exports.Prisma.TrunkProviderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  usableTrunk: 'usableTrunk',
  noneApplicable: 'noneApplicable'
};

exports.Prisma.TrunkInProgramScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  trunkId: 'trunkId',
  programId: 'programId'
};

exports.Prisma.TrunkScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  description: 'description',
  status: 'status',
  providerId: 'providerId',
  endpoint: 'endpoint',
  port: 'port',
  username: 'username',
  pwd: 'pwd',
  internalCaller: 'internalCaller',
  outerCaller: 'outerCaller',
  showPhoneType: 'showPhoneType',
  operators: 'operators',
  whitelistCity: 'whitelistCity',
  startTime: 'startTime',
  endTIme: 'endTIme',
  businessSelf: 'businessSelf',
  feePerMin: 'feePerMin',
  trunkType: 'trunkType',
  callRate: 'callRate',
  concurrency: 'concurrency',
  callTimes: 'callTimes',
  userId: 'userId'
};

exports.Prisma.BotScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  identify: 'identify',
  name: 'name',
  avatar: 'avatar',
  botState: 'botState',
  botType: 'botType',
  price: 'price',
  agencyId: 'agencyId',
  workspaceId: 'workspaceId',
  agentId: 'agentId'
};

exports.Prisma.BotAgentScalarFieldEnum = {
  id: 'id',
  trueAgentName: 'trueAgentName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  agentType: 'agentType',
  asrModelId: 'asrModelId',
  ttsModelId: 'ttsModelId',
  llmModelId: 'llmModelId',
  realtimeModelId: 'realtimeModelId',
  scriptId: 'scriptId',
  knowledgeId: 'knowledgeId',
  functionCallId: 'functionCallId',
  wordId: 'wordId',
  speed: 'speed',
  asrHotWord: 'asrHotWord',
  inboundTrunkId: 'inboundTrunkId',
  outboundTrunkId: 'outboundTrunkId',
  dispatchRuleId: 'dispatchRuleId',
  containerId: 'containerId',
  dockerImageVersion: 'dockerImageVersion',
  hotInited: 'hotInited'
};

exports.Prisma.AIModelProviderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  icon: 'icon',
  brief: 'brief',
  opend: 'opend'
};

exports.Prisma.AIModelScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  providerId: 'providerId',
  type: 'type',
  name: 'name',
  model: 'model',
  price: 'price'
};

exports.Prisma.AIModelProviderConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  icon: 'icon',
  brief: 'brief',
  opened: 'opened',
  show: 'show',
  tags: 'tags',
  apiBaseUrl: 'apiBaseUrl',
  appKey: 'appKey',
  secretKey: 'secretKey',
  apiKey: 'apiKey',
  workspaceId: 'workspaceId'
};

exports.Prisma.AIModelConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  providerConfigId: 'providerConfigId',
  type: 'type',
  name: 'name',
  model: 'model',
  voice: 'voice',
  price: 'price',
  workspaceId: 'workspaceId',
  opened: 'opened'
};

exports.Prisma.BotsInProgramScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  botId: 'botId',
  programId: 'programId'
};

exports.Prisma.SmsConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  agencyType: 'agencyType',
  smsTemplateId: 'smsTemplateId',
  appKey: 'appKey',
  secretKey: 'secretKey',
  endpoint: 'endpoint',
  name: 'name',
  signture: 'signture',
  remark: 'remark'
};

exports.Prisma.UserMediaScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  fileName: 'fileName',
  url: 'url',
  preview: 'preview',
  workspaceId: 'workspaceId',
  size: 'size',
  mimeType: 'mimeType',
  mediaFrom: 'mediaFrom',
  mediaType: 'mediaType',
  usedArea: 'usedArea',
  processState: 'processState'
};

exports.Prisma.PayOrderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  payOrderId: 'payOrderId',
  payType: 'payType',
  payItem: 'payItem',
  payAmount: 'payAmount',
  goodsAmount: 'goodsAmount',
  payUrl: 'payUrl',
  h5Url: 'h5Url',
  extra: 'extra',
  userId: 'userId',
  timeout: 'timeout',
  state: 'state'
};

exports.Prisma.QrCodeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  qr_id: 'qr_id',
  open_id: 'open_id',
  event: 'event',
  state: 'state'
};

exports.Prisma.WorkspaceConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  logo: 'logo',
  slogan: 'slogan',
  desc: 'desc',
  slogan_title: 'slogan_title',
  slogan_desc: 'slogan_desc',
  feature1_title: 'feature1_title',
  feature1_desc: 'feature1_desc',
  feature2_title: 'feature2_title',
  feature2_desc: 'feature2_desc',
  feature3_title: 'feature3_title',
  feature3_desc: 'feature3_desc',
  feature4_title: 'feature4_title',
  feature4_desc: 'feature4_desc',
  knowledge_title: 'knowledge_title',
  knowledge_desc: 'knowledge_desc',
  knowledge_link: 'knowledge_link',
  knowledge_image: 'knowledge_image',
  intro_title: 'intro_title',
  intro_desc: 'intro_desc',
  intro_link: 'intro_link',
  intro_image: 'intro_image',
  every_title: 'every_title',
  every_desc: 'every_desc',
  tool_title: 'tool_title',
  tool_desc: 'tool_desc',
  tool_link: 'tool_link',
  tool_image: 'tool_image',
  clientele_title: 'clientele_title',
  clientele_desc: 'clientele_desc',
  company: 'company',
  company_address: 'company_address',
  about_url: 'about_url',
  disclaimer_url: 'disclaimer_url',
  primary_url: 'primary_url',
  qrcode_url: 'qrcode_url',
  support_email: 'support_email',
  icp: 'icp',
  wangan: 'wangan'
};

exports.Prisma.WorkspaceRechargeRecordScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  user: 'user',
  workspaceId: 'workspaceId',
  workspace: 'workspace',
  bank: 'bank',
  bankCard: 'bankCard',
  rechargeName: 'rechargeName',
  amount: 'amount',
  state: 'state',
  explain: 'explain',
  approverId: 'approverId',
  approver: 'approver'
};

exports.Prisma.WorkspaceCostRecordScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  workspaceId: 'workspaceId',
  workspace: 'workspace',
  programId: 'programId',
  program: 'program',
  taskId: 'taskId',
  task: 'task',
  taskDetailId: 'taskDetailId',
  callPhone: 'callPhone',
  startTime: 'startTime',
  connectTIme: 'connectTIme',
  endTime: 'endTime',
  duration: 'duration',
  hashrateFee: 'hashrateFee',
  smsFee: 'smsFee',
  effectPrice: 'effectPrice',
  totalCost: 'totalCost',
  leftBalance: 'leftBalance',
  intentionStatus: 'intentionStatus',
  record_type: 'record_type'
};

exports.Prisma.ThreadScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  programId: 'programId',
  userMediaId: 'userMediaId',
  total: 'total',
  callCompleteRate: 'callCompleteRate',
  intentionRate: 'intentionRate',
  spend: 'spend',
  callTime: 'callTime',
  desc: 'desc',
  botId: 'botId',
  status: 'status',
  state: 'state'
};

exports.Prisma.ThreadDetailScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  threadId: 'threadId',
  phone: 'phone',
  data: 'data',
  detailIndex: 'detailIndex'
};

exports.Prisma.TaskScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  state: 'state',
  total: 'total',
  totalDuration: 'totalDuration',
  progress: 'progress',
  programId: 'programId',
  threadId: 'threadId',
  botId: 'botId',
  callType: 'callType',
  callStartIndex: 'callStartIndex',
  callEndIndex: 'callEndIndex',
  callDay: 'callDay',
  callStartTime: 'callStartTime',
  callEndTime: 'callEndTime',
  lunchBreak: 'lunchBreak',
  lunchStartTime: 'lunchStartTime',
  lunchEndTime: 'lunchEndTime'
};

exports.Prisma.TaskDetailScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  taskId: 'taskId',
  threadDetailId: 'threadDetailId',
  reached: 'reached',
  callMethod: 'callMethod',
  intentionRate: 'intentionRate',
  intention: 'intention',
  phoneNumber: 'phoneNumber',
  participantId: 'participantId',
  participantIdentity: 'participantIdentity',
  roomName: 'roomName',
  sipCallId: 'sipCallId',
  startTime: 'startTime',
  connectTIme: 'connectTIme',
  endTime: 'endTime',
  duration: 'duration',
  audioUrl: 'audioUrl',
  textUrl: 'textUrl',
  parsed: 'parsed',
  detailIndex: 'detailIndex'
};

exports.Prisma.TaskAnalysisScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  date: 'date',
  programId: 'programId',
  totalCount: 'totalCount',
  agentEndCount: 'agentEndCount',
  userEndCount: 'userEndCount',
  unReachedCount: 'unReachedCount',
  callRejectedCount: 'callRejectedCount',
  emptyPhoneCount: 'emptyPhoneCount',
  shutdownCount: 'shutdownCount',
  unConnectCount: 'unConnectCount',
  invalidCount: 'invalidCount',
  highCount: 'highCount',
  hesitateCount: 'hesitateCount',
  lowDifficultyCount: 'lowDifficultyCount',
  highDifficultyCount: 'highDifficultyCount',
  durationCount: 'durationCount',
  totalDuration: 'totalDuration',
  hashratePrice: 'hashratePrice',
  effectPrice: 'effectPrice',
  costPrice: 'costPrice'
};

exports.Prisma.TaskDetailExtraScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  taskDetailId: 'taskDetailId'
};

exports.Prisma.WordScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  workspaceId: 'workspaceId',
  name: 'name',
  desc: 'desc',
  content: 'content',
  state: 'state'
};

exports.Prisma.FunctionCallScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  functionId: 'functionId',
  workspaceId: 'workspaceId',
  name: 'name',
  state: 'state',
  type: 'type',
  desc: 'desc',
  content: 'content'
};

exports.Prisma.KnowledgeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  vectorId: 'vectorId',
  workspaceId: 'workspaceId',
  name: 'name',
  size: 'size',
  state: 'state',
  type: 'type',
  desc: 'desc',
  indexModel: 'indexModel',
  llmModel: 'llmModel',
  imageModel: 'imageModel',
  apiEndpoint: 'apiEndpoint',
  apiAuth: 'apiAuth',
  webEndpoint: 'webEndpoint',
  cssSelector: 'cssSelector'
};

exports.Prisma.KnowledgeDocScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  collectionName: 'collectionName',
  opened: 'opened',
  knowledgeId: 'knowledgeId',
  userMediaId: 'userMediaId',
  state: 'state'
};

exports.Prisma.KnowledgeDocTemporaryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  collectionName: 'collectionName',
  userMediaId: 'userMediaId'
};

exports.Prisma.KnowledgeItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  content: 'content',
  docId: 'docId',
  processed: 'processed',
  hash: 'hash'
};

exports.Prisma.WorkspaceInvitationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  phone: 'phone',
  workspaceId: 'workspaceId',
  type: 'type'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.Plan = exports.$Enums.Plan = {
  EXCEED: 'EXCEED',
  TRIAL: 'TRIAL',
  BASE: 'BASE',
  PRO: 'PRO',
  BUSINESS: 'BUSINESS',
  CUSTOM: 'CUSTOM',
  OFFERED: 'OFFERED',
  UNLIMITED: 'UNLIMITED'
};

exports.UserState = exports.$Enums.UserState = {
  REGISTER: 'REGISTER',
  NORMAL: 'NORMAL',
  AGENT: 'AGENT',
  CHANNEL: 'CHANNEL',
  ADMIN: 'ADMIN',
  INVALID: 'INVALID'
};

exports.UserExtraRole = exports.$Enums.UserExtraRole = {
  GOVERNMENT: 'GOVERNMENT',
  BUSINESS: 'BUSINESS',
  SALES: 'SALES',
  TECHNICAL: 'TECHNICAL',
  OTHER: 'OTHER'
};

exports.WorkspaceRole = exports.$Enums.WorkspaceRole = {
  ADMIN: 'ADMIN',
  AGENT: 'AGENT',
  CHANNEL: 'CHANNEL',
  MEMBER: 'MEMBER',
  GUEST: 'GUEST'
};

exports.AgencyState = exports.$Enums.AgencyState = {
  NORMAL: 'NORMAL',
  BANDED: 'BANDED'
};

exports.ProgramStatus = exports.$Enums.ProgramStatus = {
  Init: 'Init',
  Normal: 'Normal',
  Band: 'Band'
};

exports.ProgramWechatType = exports.$Enums.ProgramWechatType = {
  None: 'None',
  Personal: 'Personal',
  Business: 'Business'
};

exports.ProgramCallType = exports.$Enums.ProgramCallType = {
  Need: 'Need',
  Long: 'Long'
};

exports.ProgramOperationType = exports.$Enums.ProgramOperationType = {
  Generation: 'Generation',
  SelfService: 'SelfService'
};

exports.ProgramFLowType = exports.$Enums.ProgramFLowType = {
  CALL_ONLY: 'CALL_ONLY',
  FLOW: 'FLOW'
};

exports.ProgramJudgeMode = exports.$Enums.ProgramJudgeMode = {
  ScoreMode: 'ScoreMode',
  IntentionMode: 'IntentionMode'
};

exports.ProgramFrequency = exports.$Enums.ProgramFrequency = {
  ThreeDays: 'ThreeDays',
  SevenDays: 'SevenDays',
  TenDays: 'TenDays',
  ThirtyDays: 'ThirtyDays'
};

exports.TrunkStatus = exports.$Enums.TrunkStatus = {
  Normal: 'Normal',
  Band: 'Band'
};

exports.TrunkShowPhoneType = exports.$Enums.TrunkShowPhoneType = {
  FixedLine: 'FixedLine',
  VirtualTrumpet: 'VirtualTrumpet',
  RealnameMobile: 'RealnameMobile'
};

exports.TrunkOperators = exports.$Enums.TrunkOperators = {
  CMCC: 'CMCC',
  CUCC: 'CUCC',
  CTCC: 'CTCC'
};

exports.TrunkType = exports.$Enums.TrunkType = {
  FreeSwitch: 'FreeSwitch',
  SIP: 'SIP',
  PhoneNumber: 'PhoneNumber',
  AX: 'AX'
};

exports.BotState = exports.$Enums.BotState = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE'
};

exports.BotType = exports.$Enums.BotType = {
  Intention: 'Intention',
  Home: 'Home',
  Artificial: 'Artificial',
  SMSVerification: 'SMSVerification',
  Satisfaction: 'Satisfaction'
};

exports.BotAgentType = exports.$Enums.BotAgentType = {
  REALTIME: 'REALTIME',
  ASR_LLM_TTS: 'ASR_LLM_TTS'
};

exports.AIModelType = exports.$Enums.AIModelType = {
  LANGUAGE: 'LANGUAGE',
  ASR: 'ASR',
  TTS: 'TTS',
  INDEX: 'INDEX',
  Embedding: 'Embedding',
  IMAGE: 'IMAGE',
  REALTIME: 'REALTIME'
};

exports.SmsConfigAgency = exports.$Enums.SmsConfigAgency = {
  ALI: 'ALI',
  LIANLU: 'LIANLU'
};

exports.UserMediaFrom = exports.$Enums.UserMediaFrom = {
  UPLOAD: 'UPLOAD',
  COLLECT: 'COLLECT',
  AI_CREATED: 'AI_CREATED'
};

exports.UserMediaType = exports.$Enums.UserMediaType = {
  EXCEL: 'EXCEL',
  PDF: 'PDF',
  IMAGE: 'IMAGE',
  PPT: 'PPT',
  WORD: 'WORD',
  OTHER: 'OTHER'
};

exports.UserMediaUsedArea = exports.$Enums.UserMediaUsedArea = {
  TASK: 'TASK',
  REPO: 'REPO'
};

exports.UserMediaProcessState = exports.$Enums.UserMediaProcessState = {
  IDLE: 'IDLE',
  WAITING: 'WAITING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  INVALID: 'INVALID'
};

exports.PayType = exports.$Enums.PayType = {
  WeChat: 'WeChat',
  Alipay: 'Alipay',
  Bank: 'Bank'
};

exports.PayItem = exports.$Enums.PayItem = {
  TRIAL: 'TRIAL',
  BASE: 'BASE',
  PRO: 'PRO',
  BUSINESS: 'BUSINESS',
  CUSTOM: 'CUSTOM',
  TEMPLATE: 'TEMPLATE',
  PROXY: 'PROXY',
  CHANNEL: 'CHANNEL',
  CDKEY: 'CDKEY'
};

exports.PayOrderState = exports.$Enums.PayOrderState = {
  Waiting: 'Waiting',
  Paying: 'Paying',
  Success: 'Success',
  Failed: 'Failed',
  Timeout: 'Timeout',
  Refund: 'Refund',
  Closed: 'Closed'
};

exports.RechargeState = exports.$Enums.RechargeState = {
  WAITING: 'WAITING',
  REJECTED: 'REJECTED',
  APPROVED: 'APPROVED'
};

exports.PlanRecordType = exports.$Enums.PlanRecordType = {
  RECHARGE: 'RECHARGE',
  PRESENT: 'PRESENT',
  EXPEND: 'EXPEND',
  EXCEED: 'EXCEED'
};

exports.ThreadStatus = exports.$Enums.ThreadStatus = {
  INIT: 'INIT',
  WAITING: 'WAITING',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE'
};

exports.ThreadState = exports.$Enums.ThreadState = {
  NORMAL: 'NORMAL',
  DELETED: 'DELETED'
};

exports.TaskState = exports.$Enums.TaskState = {
  WAITING: 'WAITING',
  PREPARE: 'PREPARE',
  RUNNING: 'RUNNING',
  PAUSE: 'PAUSE',
  BLOCKING: 'BLOCKING',
  COMPLETE: 'COMPLETE',
  FAILED: 'FAILED'
};

exports.TaskCallType = exports.$Enums.TaskCallType = {
  ALL: 'ALL',
  PART: 'PART'
};

exports.TaskCallDay = exports.$Enums.TaskCallDay = {
  EVERYDAY: 'EVERYDAY',
  WEEKDAY: 'WEEKDAY',
  NO_SUNDAY: 'NO_SUNDAY'
};

exports.TaskLunchBreak = exports.$Enums.TaskLunchBreak = {
  BREAK: 'BREAK',
  NO_BREAK: 'NO_BREAK'
};

exports.TaskDetailReachStatus = exports.$Enums.TaskDetailReachStatus = {
  INIT: 'INIT',
  PREPARE: 'PREPARE',
  DIALED: 'DIALED',
  REACHED: 'REACHED',
  AGENT_END: 'AGENT_END',
  USER_END: 'USER_END',
  UNREACHED: 'UNREACHED',
  CALL_REJECTED: 'CALL_REJECTED',
  EMPTY_PHONE: 'EMPTY_PHONE',
  SHUTDOWN: 'SHUTDOWN',
  UN_CONNECT: 'UN_CONNECT',
  INVALID: 'INVALID'
};

exports.TaskDetailCallMethod = exports.$Enums.TaskDetailCallMethod = {
  FREESWITCH: 'FREESWITCH',
  SIP: 'SIP',
  WEB: 'WEB'
};

exports.TaskDetailIntention = exports.$Enums.TaskDetailIntention = {
  NONE: 'NONE',
  REACHED: 'REACHED',
  HIGH: 'HIGH',
  HESITATE: 'HESITATE',
  LOW_DIFFICULTY: 'LOW_DIFFICULTY',
  HIGH_DIFFICULTY: 'HIGH_DIFFICULTY',
  UNKNOW: 'UNKNOW'
};

exports.WordState = exports.$Enums.WordState = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE'
};

exports.FunctionState = exports.$Enums.FunctionState = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE'
};

exports.FunctionType = exports.$Enums.FunctionType = {
  FUNC: 'FUNC',
  MCP: 'MCP'
};

exports.KnowledgeState = exports.$Enums.KnowledgeState = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE'
};

exports.KnowledgeType = exports.$Enums.KnowledgeType = {
  SYS: 'SYS',
  NORMAL: 'NORMAL',
  API: 'API',
  WEB: 'WEB'
};

exports.KnowledgeDocState = exports.$Enums.KnowledgeDocState = {
  SYS: 'SYS',
  INIT: 'INIT',
  PROCESSING: 'PROCESSING',
  READY: 'READY',
  INVALID: 'INVALID'
};

exports.KnowledgeItemType = exports.$Enums.KnowledgeItemType = {
  NORMAL: 'NORMAL',
  QA: 'QA'
};

exports.Prisma.ModelName = {
  Project: 'Project',
  Clue: 'Clue',
  ClueStatus: 'ClueStatus',
  CallRecord: 'CallRecord',
  PushRecord: 'PushRecord',
  Sms: 'Sms',
  Session: 'Session',
  User: 'User',
  UserExtra: 'UserExtra',
  UserApplyHistory: 'UserApplyHistory',
  Workspace: 'Workspace',
  MemberInWorkspace: 'MemberInWorkspace',
  Agency: 'Agency',
  ProgramCategory: 'ProgramCategory',
  Program: 'Program',
  TrunkScript: 'TrunkScript',
  TrunkProvider: 'TrunkProvider',
  TrunkInProgram: 'TrunkInProgram',
  Trunk: 'Trunk',
  Bot: 'Bot',
  BotAgent: 'BotAgent',
  AIModelProvider: 'AIModelProvider',
  AIModel: 'AIModel',
  AIModelProviderConfig: 'AIModelProviderConfig',
  AIModelConfig: 'AIModelConfig',
  BotsInProgram: 'BotsInProgram',
  SmsConfig: 'SmsConfig',
  UserMedia: 'UserMedia',
  PayOrder: 'PayOrder',
  QrCode: 'QrCode',
  WorkspaceConfig: 'WorkspaceConfig',
  WorkspaceRechargeRecord: 'WorkspaceRechargeRecord',
  WorkspaceCostRecord: 'WorkspaceCostRecord',
  Thread: 'Thread',
  ThreadDetail: 'ThreadDetail',
  Task: 'Task',
  TaskDetail: 'TaskDetail',
  TaskAnalysis: 'TaskAnalysis',
  TaskDetailExtra: 'TaskDetailExtra',
  Word: 'Word',
  FunctionCall: 'FunctionCall',
  Knowledge: 'Knowledge',
  KnowledgeDoc: 'KnowledgeDoc',
  KnowledgeDocTemporary: 'KnowledgeDocTemporary',
  KnowledgeItem: 'KnowledgeItem',
  WorkspaceInvitation: 'WorkspaceInvitation'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
